import React from "react";
import FormLayout from '../FormLayout';
import TextField from './TextField';
import { Field } from 'redux-form';
import CKWysiwygField from '../../components/CKWysiwygField';
import TranslatableWysiwygField from '../../components/TranslatableWysiwygField';
import Utils from '../../services/Utils';

/** Class representing a form layout rich text field. */
class RichTextField extends TextField {

    constructor(properties) {
        super({
            ...(RichTextField.getDefaultOptions()),
            ...properties,
        });

        this.type = FormLayout.RICHTEXT;
        this.multilingual = !!this.multilingual;
    }

    /**
     * Get this field default options
     */
    static getDefaultOptions() {
        const properties = super.getDefaultOptions();
        // Most forms (e.g. volunteer applications) collect one answer in the form locale.
        properties.multilingual = false;
        return properties;
    }

    getHandledOptions() {
        return super.getHandledOptions()
            .filter(o => o !== FormLayout.OPTION_PLACEHOLDER)
            .concat([FormLayout.OPTION_MULTILINGUAL]);
    }

    /**
     * Return this field preview input
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getInput(props) {
        const component = this.multilingual
            ? TranslatableWysiwygField
            : CKWysiwygField;

        return (
            <Field
                component={ component }
                name={this.reduxFieldName(props)}
                required={this.htmlRequired(props)}
                className="form-control"
            />
        );
    }


    /**
     * Render a value
     *
     * @param {Any} value
     * @param {Object} context: an object with the following keys:
     *                   - lang (mandatory)
     *                   - t (mandatory)
     *                   - format (optional)
     *
     * @return {String|JSX.Element}
     */
    renderValue(value, context) {
        let html = value;
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            html = Utils.localized_or_fallback(value, context?.lang, '');
        } else if (Array.isArray(value)) {
            html = value.map(v => this.renderValue(v, context)).join('');
        }

        if (html == null || html === '')
            return '';

        // Legacy corruption from PHP strval(array) — content is unrecoverable
        if (html === 'Array')
            return '';

        return <span dangerouslySetInnerHTML={{ __html: html }}></span>;
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'align-center';
    }
}

export default RichTextField;
